export default __webpack_public_path__ + "static/media/completed.cba5a583.svg";